import { render, staticRenderFns } from "./UveitisDialogs.vue?vue&type=template&id=44c7c972&scoped=true&"
import script from "./UveitisDialogs.vue?vue&type=script&lang=js&"
export * from "./UveitisDialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7c972",
  null
  
)

export default component.exports